import CustomerProfile1 from "../../Assets/images/Customer-profile.png"
import CustomerProfile2 from "../../Assets/images/BestTraveler1-profile.png"
import CustomerProfile3 from "../../Assets/images/BestTraveler2-profile.png"
import CustomerProfile4 from "../../Assets/images/BestTraveler3-profile.png"
import CustomerProfile5 from "../../Assets/images/BestTraveler4-profile.png"
export const TestimonialsData = [{
        name: "Jaylon Vaccaro",
        CustomerProfile: CustomerProfile1,
        rating: 5,
        testimonials: "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don"
    },
    {
        name: "Zaire Vetrovs",
        CustomerProfile: CustomerProfile2,
        rating: 4,
        testimonials: "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don"
    },
    {
        name: "Marcus Dias",
        CustomerProfile: CustomerProfile3,
        rating: 5,
        testimonials: "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don"
    },
    {
        name: "Davis Schleifer",
        CustomerProfile: CustomerProfile4,
        rating: 5,
        testimonials: "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don"
    },
    {
        name: "Raju Mullah",
        CustomerProfile: CustomerProfile5,
        rating: 5,
        testimonials: "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don"
    }

]